import React from "react";
import { Copy, ExternalLink } from "lucide-react";

export default function ShareMenu({ url, text, onClose, onToast }) {
    const tryNative = async () => {
        if (navigator.share) {
            try {
                await navigator.share({ title: text, text, url });
                onClose();
                return true;
            } catch {
                /* user cancelled or share failed */
            }
        }
        return false;
    };

    React.useEffect(() => {
        (async () => {
            const ok = await tryNative();
            if (ok) return;
        })();
    }, []);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            onToast("Link copied");
        } catch {
            onToast("Copy failed");
        }
        onClose();
    };
    const openInNew = (u) => {
        window.open(u, "_blank", "noopener,noreferrer");
        onClose();
    };

    return (
        <div
            className="absolute right-0 bottom-full mb-2 card-soft py-1.5 w-52 z-[560]"
            onClick={(e) => e.stopPropagation()}
            data-testid="share-menu"
        >
            <button
                className="w-full text-left px-3 py-2 hover:bg-slate-50 text-[13.5px] flex items-center gap-2"
                onClick={() =>
                    openInNew(
                        `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`,
                    )
                }
                data-testid="share-whatsapp"
            >
                <ExternalLink className="w-3.5 h-3.5 text-green-600" /> WhatsApp
            </button>
            <button
                className="w-full text-left px-3 py-2 hover:bg-slate-50 text-[13.5px] flex items-center gap-2"
                onClick={() =>
                    openInNew(
                        `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
                    )
                }
                data-testid="share-twitter"
            >
                <ExternalLink className="w-3.5 h-3.5 text-slate-700" /> X / Twitter
            </button>
            <button
                className="w-full text-left px-3 py-2 hover:bg-slate-50 text-[13.5px] flex items-center gap-2"
                onClick={() =>
                    openInNew(
                        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
                    )
                }
                data-testid="share-facebook"
            >
                <ExternalLink className="w-3.5 h-3.5 text-blue-600" /> Facebook
            </button>
            <button
                className="w-full text-left px-3 py-2 hover:bg-slate-50 text-[13.5px] flex items-center gap-2 border-t border-slate-100 mt-1"
                onClick={copy}
                data-testid="share-copy"
            >
                <Copy className="w-3.5 h-3.5 text-[#e85812]" /> Copy link
            </button>
        </div>
    );
}
